import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { unstyledStyle } from './Unstyled.css';
import { getClassNames } from '../../util/css';

export const Unstyled = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  ({ children, className, ...props }, ref) => (
    <div ref={ref} {...props} className={getClassNames(unstyledStyle, className)}>
      {children}
    </div>
  ),
);
